module.exports = __webpack_public_path__ + "static/media/icon_sauna.0423276f.svg";